import React from "react";
import Organization from "../../Organization";
import { OnboardingFormProps } from "../Types";

const InviteStep: React.FC<OnboardingFormProps> = () => (
  <div style={{ width: "100%", maxWidth: "800px", textAlign: "left" }}>
    <h1>👥 Team</h1>
    <p style={{ marginTop: 0, marginBottom: "24px", color: "#6b7280" }}>
      Add teammates to collaborate on your newsletter.
    </p>
    <Organization />
  </div>
);

export default InviteStep;
